<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <fa-icon [icon]="actionIcon"></fa-icon>
    <h2 ngpDialogTitle>
      {{ "feed-manual-order.title.arrange-posts" | translate }}
    </h2>
    <h2 ngpDialogDescription>{{ title }}</h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>
  <ng-template suiDialogContent>
    <div class="manual-order">
      <p class="manual-order__hint">
        {{
          "feed-manual-order.hint.drag-the-posts-into-the-order-of-the-report"
            | translate
        }}
      </p>
      @if (dimensionNames) {
        <p class="manual-order__hint">
          {{
            "feed-manual-order.hint.the-widget-shows-the-feed-filtered-by"
              | translate
          }}
          {{ dimensionNames }}
        </p>
      }
      @if (loading()) {
        <div class="manual-order__list">
          <app-loading-card
            type="post"
            [count]="skeletonCount"
            [animationEnabled]="true"
          ></app-loading-card>
        </div>
      } @else if (posts().length === 0) {
        <sui-empty-state
          size="page"
          [icon]="actionIcon"
          [title]="
            'feed-manual-order.empty.no-posts-in-the-current-period' | translate
          "
        ></sui-empty-state>
      } @else {
        @if (capReached()) {
          <p class="manual-order__cap">
            {{
              "feed-manual-order.hint.the-list-shows-the-first-500-posts"
                | translate
            }}
          </p>
        }
        <div
          class="manual-order__list"
          cdkDropList
          [cdkDropListData]="posts()"
          (cdkDropListDropped)="onDrop($event)"
        >
          @for (post of posts(); track post.id) {
            <app-post-card
              cdkDrag
              [cdkDragData]="post"
              [post]="post"
              [viewMode]="'compact'"
              [sortable]="true"
              [selectable]="false"
              [disableTools]="true"
              [timeShown]="timeShown()"
            ></app-post-card>
          }
        </div>
      }
    </div>
  </ng-template>
  <ng-template suiDialogFooter>
    <sui-button size="sm" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!dirty() || saving()"
      (click)="save()"
    >
      {{ "btn.save" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
